import { Button, Spinner } from '@here/components'
import { user } from '@state'
import { createQuery } from '@tanstack/solid-query'
import { Show } from 'solid-js'
import { apiClient } from '../../../utils/api-client'

export const PaymentsPortalButton = () => {
  const portalQuery = createQuery(() => ({
    queryKey: ['payments-portal-link'],
    queryFn: async () => {
      const result = await apiClient.getPaymentsLink()

      if (result.status !== 200) {
        throw new Error('Failed to fetch portal link')
      }

      return result.body
    },
    enabled: !!user()?.access_token,
  }))

  return (
    <Show
      when={!portalQuery.isError}
      fallback={<Button disabled>Error loading portal</Button>}
    >
      <Button
        as="a"
        href={portalQuery.data?.url}
        disabled={portalQuery.isLoading}
        colorPalette="tscGreen"
        variant="solid"
        rel="noopener noreferrer"
        w="full"
        mt={4}
      >
        <Show when={portalQuery.isLoading} fallback="Manage Subscription">
          <Spinner
            size="sm"
            mr={2}
          />
          Loading...
        </Show>
      </Button>
    </Show>
  )
}
